import * as types from '../actions/action-types';

const initialState = {
  trackingLogs: [],
  getTrackingLogsError: null,
  totalPages: 0,
  totalElements: 0,
};

const managementTrackingReducer = function(state = initialState, action) {
  switch (action.type) {
    case types.GET_TRACKING_LOGS_SUCCESS:
      return Object.assign({}, state, {
        trackingLogs: action.data.content,
        totalPages: action.data.totalPages,
        totalElements: action.data.totalElements,
        getTrackingLogsError: null,
      });
    case types.GET_TRACKING_LOGS_ERROR:
      return Object.assign({}, state, {
        trackingLogs: [],
        getTrackingLogsError: action.error,
        totalPages: 0,
        totalElements: 0,
      });
  }
  return state;
};

export default managementTrackingReducer;
